import { useCallback, useState } from 'react'

export function useChapterWipe(initialChapter = 'intake') {
  const [chapter, setChapter] = useState(initialChapter)
  const [wipeState, setWipeState] = useState('idle')

  const goChapter = useCallback((nextChapter) => {
    setChapter((current) => {
      if (nextChapter === current) return current
      setWipeState('in')
      window.setTimeout(() => {
        setChapter(nextChapter)
        setWipeState('out')
        window.setTimeout(() => setWipeState('idle'), 430)
      }, 520)
      return current
    })
  }, [])

  return { chapter, wipeState, goChapter, setChapter }
}
